import { LOCALLANGUAGE } from '@Constants/LocalStorage'
import { get, set } from '@Core/LocalStorage'

export const setLocalLanguage = (value) => set(LOCALLANGUAGE, value)
export const getLocalLanguage = () => get(LOCALLANGUAGE) || 'en'
